import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import './styles.scss';

const index = props => {
  const { text, onClick, className, disabled } = props;

  return (
    <Button className={`ant-btn-lg ${className}`} onClick={onClick} disabled={disabled}>
      {text}
    </Button>
  );
};

index.defaultProps = {
  className: '',
  disabled: false,
};

index.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default index;
